import React from "react";

interface IErrorBoundaryProps {
  children?: React.ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

// Without this, any render error unmounts the whole tree and the user sees a blank page.
class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  state: IErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Unhandled render error", error, info?.componentStack);
    try {
      (window as any).mixpanel?.track?.("error_triggered", {
        error_type: "render_crash",
        error_message: String(error?.message || error),
        page_path: window.location.pathname,
        user_agent: navigator.userAgent,
      });
    } catch (e) {
      // never let reporting break the fallback
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{ padding: "40px 16px", textAlign: "center", fontFamily: "sans-serif" }}
        >
          <h2>Something went wrong</h2>
          <p>Please refresh the page. If the problem continues, contact support.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
